import { createFileRoute } from "@tanstack/react-router"

import { ReviewStep } from "@/features/membership/application/components/review-step"

export const Route = createFileRoute("/membership/apply/review")({
  component: ReviewStep,
})
